import { lazy, Suspense, useEffect, useState } from 'react';
import { useAppSelector } from '../../../../core/rootHooks';
import { selectVesselsLastSignalData } from '../../../main-map/mapSelectors';
import { TVesselInfo } from '../../../main-map/mapTypes';
import { Layer, Source } from 'react-map-gl';
import { pointArrowLayerStyle } from '../../../../shared/components/globe-map/constants/mapLayers';
import { findCenterPoint } from '../../../../utils/mapHelpers';
import LoadingSpinner from '../../../../shared/components/loading-spinner/LoadingSpinner';

const GlobeMap = lazy(() => import('../../../../shared/components/globe-map/GlobeMap'));

interface IFleetKpiProps {
	imoList: number[];
}

const SectorKpiMap: React.FC<IFleetKpiProps> = ({ ...props }) => {
	const vesselsLastSignalData = useAppSelector(selectVesselsLastSignalData);

	const [vesselsLastSignalDataFiltered, setVesselsLastSignalDataFiltered] = useState<TVesselInfo | null>(null);

	useEffect(() => {
		if (
			props.imoList.length > 0 &&
			vesselsLastSignalData &&
			vesselsLastSignalData.features &&
			vesselsLastSignalData.features.length > 0
		) {
			const filteredVesselsLastSignalData =
				vesselsLastSignalData!.features.filter((feature) => props.imoList.includes(feature.properties!.imoNumber)) || null;

			if (filteredVesselsLastSignalData) {
				const signalInfo: TVesselInfo = {
					type: 'FeatureCollection',
					features: filteredVesselsLastSignalData,
				};

				setVesselsLastSignalDataFiltered(signalInfo);
			}
		}
	}, [vesselsLastSignalData, props.imoList]);

	return (
		<>
			{vesselsLastSignalDataFiltered && (
				<Suspense fallback={<LoadingSpinner size="lg" />}>
					<GlobeMap center={findCenterPoint(vesselsLastSignalDataFiltered!)} zoomLevel={1.85}>
						<Source id="points" type="geojson" data={vesselsLastSignalDataFiltered}>
							<Layer {...pointArrowLayerStyle(3)} type="symbol" />
						</Source>
					</GlobeMap>
				</Suspense>
			)}
		</>
	);
};

export default SectorKpiMap;
